import moment from "moment";
import React, { useState } from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { sharedRequests } from "@/api/(requests)/shared";

import { AddendumDisplay } from "./components/AddendumDisplay";
import { AddendumForm } from "./components/AddendumForm";
import { AddendumLink } from "./components/AddendumLink";

import "./NoteAddendum.styles.scss";

export function NoteAddendum({
  addendum,
  credentials,
  noteId,
  onSubmit,
  patientId,
  signature,
  textTestId,
  timestamp,
}) {
  const [isForm, setIsForm] = useState(false);

  const submitAddendum = async (addendum) => {
    const urlParams = { patientId };
    const data = {
      addendum,
      credentials,
      note_id: noteId,
      signature,
      timestamp: moment().unix(),
    };

    await sharedRequests.create_note_addendum({ data, urlParams });
    onSubmit(data);
  };

  return (
    <DashboardCard2 className="NoteAddendum tw:w-full" classNameChildren="tw:flex tw:w-full">
      {!addendum && !isForm && <AddendumLink onClick={() => setIsForm(true)} />}
      {!addendum && isForm && (
        <AddendumForm
          onCancel={() => setIsForm(false)}
          onSubmit={async (formData) => {
            await submitAddendum(formData.addendum);
            setIsForm(false);
          }}
        />
      )}

      {addendum && !isForm && (
        <AddendumDisplay
          addendum={addendum}
          credentials={credentials}
          signature={signature}
          textTestId={textTestId}
          timestamp={timestamp}
        />
      )}
    </DashboardCard2>
  );
}
